
export const initQandA = () => {
  const acc = document.getElementsByClassName('question-wrapper')

  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener('click', function(e) {

      if (e.target.tagName === 'A')
        return

      for (var j = acc.length - 1; j >= 0; j--) { acc[j].classList.remove('active') }

      const hidden = this.querySelector('.answer')

      if (hidden.style.maxHeight) {
        hidden.style.maxHeight = null

      } else {
        acc[i].classList.add('active')

        // close others
        for (var j = acc.length - 1; j >= 0; j--) {
          const hidden2 = acc[j].querySelector('.answer');
          hidden2.style.maxHeight = null
        }
        // end close others
        hidden.style.maxHeight = hidden.scrollHeight + 'px'
      }
    })
  }
}
